import React from 'react';
import { motion } from 'framer-motion';
export function ScienceSection() {
  return <section id="ciencia" className="py-20 md:py-32 bg-dark relative overflow-hidden" data-id="element-170">
      {/* Background accents */}
      <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-green-brand/5 rounded-full blur-[120px] pointer-events-none" data-id="element-171"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-172">
        <div className="text-center mb-16" data-id="element-173">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="text-3xl md:text-5xl font-heading text-white mb-6" data-id="element-174">
            La Proporción 40:1: <br className="hidden md:block" data-id="element-175" />
            <span className="text-green-brand" data-id="element-176">
              El Código Maestro de tu Ovario.
            </span>
          </motion.h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-177">
          {/* CSS Illustration of Balance */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="relative h-[400px] bg-dark-surface rounded-3xl border border-dark-card p-8 flex flex-col justify-center" data-id="element-178">
            <div className="absolute inset-0 bg-gradient-to-b from-transparent to-dark-card/50 rounded-3xl" data-id="element-179"></div>

            <div className="relative z-10 flex justify-between items-end h-full pb-10 px-4" data-id="element-180">
              {/* Imbalance Side */}
              <div className="flex flex-col items-center w-1/2" data-id="element-181">
                <div className="text-pink-brand font-bold mb-4 text-center" data-id="element-182">
                  Desequilibrio
                  <br data-id="element-183" />
                  <span className="text-sm font-normal opacity-80" data-id="element-184">
                    (SOP / Resistencia)
                  </span>
                </div>
                <div className="flex items-end gap-2 h-40" data-id="element-185">
                  <motion.div initial={{
                  height: 0
                }} whileInView={{
                  height: '100%'
                }} viewport={{
                  once: true
                }} transition={{
                  duration: 1,
                  delay: 0.5
                }} className="w-12 bg-pink-brand/80 rounded-t-md relative" data-id="element-186">
                    <span className="absolute -top-6 left-1/2 -translate-x-1/2 text-xs text-white" data-id="element-187">
                      Myo
                    </span>
                  </motion.div>
                  <motion.div initial={{
                  height: 0
                }} whileInView={{
                  height: '80%'
                }} viewport={{
                  once: true
                }} transition={{
                  duration: 1,
                  delay: 0.7
                }} className="w-12 bg-pink-brand/40 rounded-t-md relative" data-id="element-188">
                    <span className="absolute -top-6 left-1/2 -translate-x-1/2 text-xs text-white" data-id="element-189">
                      D-Chiro
                    </span>
                  </motion.div>
                </div>
                <div className="w-full h-1 bg-pink-brand/30 mt-4 rounded-full" data-id="element-190"></div>
              </div>

              {/* Balance Side */}
              <div className="flex flex-col items-center w-1/2" data-id="element-191">
                <div className="text-green-brand font-bold mb-4 text-center" data-id="element-192">
                  Proporción 40:1
                  <br data-id="element-193" />
                  <span className="text-sm font-normal opacity-80" data-id="element-194">
                    (Salud)
                  </span>
                </div>
                <div className="flex items-end gap-2 h-40" data-id="element-195">
                  <motion.div initial={{
                  height: 0
                }} whileInView={{
                  height: '100%'
                }} viewport={{
                  once: true
                }} transition={{
                  duration: 1,
                  delay: 0.9
                }} className="w-12 bg-green-brand/80 rounded-t-md relative shadow-[0_0_15px_rgba(139,195,74,0.5)]" data-id="element-196">
                    <span className="absolute -top-6 left-1/2 -translate-x-1/2 text-xs text-white" data-id="element-197">
                      40
                    </span>
                  </motion.div>
                  <motion.div initial={{
                  height: 0
                }} whileInView={{
                  height: '10%'
                }} viewport={{
                  once: true
                }} transition={{
                  duration: 1,
                  delay: 1.1
                }} className="w-12 bg-green-brand/40 rounded-t-md relative" data-id="element-198">
                    <span className="absolute -top-6 left-1/2 -translate-x-1/2 text-xs text-white" data-id="element-199">
                      1
                    </span>
                  </motion.div>
                </div>
                <div className="w-full h-1 bg-green-brand/50 mt-4 rounded-full shadow-[0_0_10px_rgba(139,195,74,0.5)]" data-id="element-200"></div>
              </div>
            </div>

            {/* Scale base */}
            <div className="absolute bottom-8 left-1/2 -translate-x-1/2 w-32 h-2 bg-gray-700 rounded-full" data-id="element-201"></div>
            <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-0 h-0 border-l-[20px] border-l-transparent border-r-[20px] border-r-transparent border-b-[32px] border-b-gray-600" data-id="element-202"></div>
          </motion.div>

          {/* Educational Copy */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.3
        }} className="space-y-6 text-lg text-gray-300" data-id="element-203">
            <p data-id="element-204">
              "La ciencia ha demostrado que el tejido ovárico sano mantiene
              exactamente{' '}
              <strong className="text-white" data-id="element-205">
                40 partes de Myo-Inositol por 1 parte de D-Chiro-Inositol
              </strong>
              . Esta no es una cifra al azar; es la frecuencia exacta en la que
              la insulina y las hormonas se entienden."
            </p>
            <p data-id="element-206">
              Cuando tomas inositol genérico o incompleto, la señal se pierde.
              MyoChiro-Pro replica esta proporción natural para que tu cuerpo
              vuelva a entender sus propias instrucciones.
            </p>

            <div className="pt-6" data-id="element-207">
              <div className="inline-flex items-center gap-3 bg-dark-surface border border-dark-card px-6 py-3 rounded-full" data-id="element-208">
                <div className="w-3 h-3 rounded-full bg-green-brand animate-pulse" data-id="element-209"></div>
                <span className="text-sm font-medium text-white" data-id="element-210">
                  Comunicación celular restaurada
                </span>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}